import React from 'react';

const Quote = () => (
  <div className="quotes-paragraph">
    <p>Mathematics is not about number, equations,computation,</p>
    <p>or algorith: It is about understanding. _ William paul thurston</p>
  </div>
);
export default Quote;
